// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__FmUno","title":"Info_title__zNCPu","links":"Info_links__2bZIo","link":"Info_link__2fhMP","logo":"Info_logo__GSyAM"};